/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/camelcase */
import { Vue, Component } from 'vue-property-decorator';
import { orderBy, slice } from 'lodash';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';

@Component
export default class VuetableMixin extends Vue {
  $refs!: {
    vuetable: any;
    pagination: any;
  }

  tableCss = {
    tableClass: 'table-divided order-with-arrow',
  }

  sortMode = false;

  vuetablePrepage = 10;

  searchKeywords = '';

  tablePagination: VuetablePagination = {
    current_page: 0,
    from: 0,
    last_page: 0,
    per_page: 0,
    to: 0,
    total: 0,
  }

  get filterKeyword() {
    // Convert wildcard search. (?|*)
    return this.searchKeywords.replace(/(\?|\*)/g, '\\w');
  }

  vuetableDataManager<T>(
    sortOrder: VuetableSortOrder[],
    _pagination: VuetablePagination,
    vuetable: any,
    dataRef: Array<T>,
  ): {
    pagination: VuetablePagination;
    data: Array<T>;
  } {
    if (dataRef.length < 1) {
      return {
        pagination: vuetable.makePagination(
          0,
          this.vuetablePrepage || vuetable.perPage,
        ),
        data: [],
      };
    }

    let local = dataRef;

    // sortOrder can be empty, so we have to check for that as well
    if (sortOrder.length > 0) {
      // console.log('orderBy:', sortOrder[0].sortField, sortOrder[0].direction);
      local = orderBy(
        local,
        sortOrder.map((s) => s.sortField), // use map to get multiple order fields.
        sortOrder.map((s) => s.direction), // use map to get multiple order fields.
      );
    }

    const newPagination = vuetable.makePagination(
      local.length,
      this.vuetablePrepage || vuetable.perPage,
    );
    // console.log('pagination:', newPagination);
    const from = newPagination.from - 1;
    const to = from + (this.vuetablePrepage || vuetable.perPage);
    const data = slice(local, from, to);

    return {
      pagination: newPagination,
      data,
    };
  }

  searchChange(searchText: string) {
    this.searchKeywords = searchText;
  }
}
